import React from 'react'
import Title from '../../../Components/Title/Title'
import styles from './EuropeanWindows.module.css'
import {
  EuropeanWindowsIcon1,
  EuropeanWindowsIcon2, EuropeanWindowsIcon3, EuropeanWindowsIcon4,
} from '../../../Assets/Images/WindowsPage/European/Index'

const EuropeanWindows = () => {
  return (
    <div className={styles.container}>
      <div className={`${styles.wrap} customContainer`}>
        <Title title="European windows" />

        <div className={styles.wrapper}>
          {/* LEFT */}
          <div className={styles.left}>
            <p className={styles.description}>
              Windows imported by XLeum, represent the best of European manufacturing by combining precision, innovation
              and durability. Produced from high-quality PVC and aluminum profiles, these windows meet modern world
              standards for insulation, safety and comfort. Each model is engineered for performance:
              from energy-efficient glazing to secure hardware and elegant finishes that fit any architectural style.
            </p>

            <div className={styles.cards}>
              <div className={styles.card}>
                <img src={EuropeanWindowsIcon1} alt="" />
                <p className={styles.cardTitle}>World-Class insulation</p>
                <span className={styles.line}></span>
              </div>

              <div className={styles.card}>
                <img src={EuropeanWindowsIcon4} alt="" />
                <p className={styles.cardTitle}>Modern design</p>
                <span className={styles.line}></span>
              </div>

              <div className={styles.card}>
                <img src={EuropeanWindowsIcon3} alt="" />
                <p className={styles.cardTitle}>Reliability and durability</p>
                <span className={styles.line}></span>
              </div>

              <div className={styles.card}>
                <img src={EuropeanWindowsIcon2} alt="" />
                <p className={styles.cardTitle}>Easy maintenance</p>
                <span className={styles.line}></span>
              </div>
            </div>
          </div>

          {/* RIGHT IMG */}
          < div className={styles.right} />
        </div>
      </div>
    </div>
  )
}

export default EuropeanWindows
